import React from 'react';
import type { VanLifePark, VanLifePlayer } from '../../../../games/van-life/van-life';
import { ZONE_CARDS, CHALLENGE_CARDS } from '../../../../games/van-life/van-life';

interface Props {
  park: VanLifePark;
  player: VanLifePlayer;
  isMe: boolean;
}

export default function ParkInfoPanel({ park, player, isMe }: Props) {
  const zone      = ZONE_CARDS.find(z => z.id === park.zoneCardId)!;
  const challenge = CHALLENGE_CARDS.find(c => c.id === park.challengeCardId)!;
  const isTrack   = player.playerNumber === 1;
  return (
    <div className={`rounded-lg border p-3 text-sm ${isMe ? 'border-amber-600 bg-amber-950/20' : 'border-gray-700 bg-gray-900/50'}`}>
      <div className="flex items-center gap-2 mb-2 flex-wrap">
        <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ background: player.color }} />
        <span className="font-semibold text-amber-200">{player.name}</span>
        <span className={`text-xs px-1.5 py-0.5 rounded font-semibold ${
          isTrack ? 'bg-blue-900/60 text-blue-300' : 'bg-green-900/60 text-green-300'
        }`}>
          {isTrack ? 'Track Player' : 'Challenge Player'}
        </span>
        {isMe && <span className="text-xs text-gray-500">(you)</span>}
        {park.conquered && <span className="text-yellow-400 ml-auto">★</span>}
      </div>
      <div className="text-xs font-bold text-gray-300 mb-1">{park.name}</div>
      <div className="space-y-1">
        <div className={isTrack ? '' : 'opacity-40'}>
          <span className={`text-xs font-semibold ${isTrack ? 'text-amber-400' : 'text-gray-500'}`}>
            {isTrack ? '★ Zone: ' : 'Zone: '}
          </span>
          <span className={`text-xs font-semibold ${isTrack ? 'text-amber-300' : 'text-gray-400'}`}>{zone.name}</span>
          <div className="text-gray-500 text-xs leading-tight mt-0.5">{zone.description}</div>
        </div>
        <div className={!isTrack ? '' : 'opacity-40'}>
          <span className={`text-xs font-semibold ${!isTrack ? 'text-green-400' : 'text-gray-500'}`}>
            {!isTrack ? '★ Challenge: ' : 'Challenge: '}
          </span>
          <span className={`text-xs font-semibold ${!isTrack ? 'text-green-300' : 'text-gray-400'}`}>{challenge.name}</span>
          <div className="text-gray-500 text-xs leading-tight mt-0.5">{challenge.description}</div>
        </div>
      </div>
    </div>
  );
}
